import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import courseRegisterIndividualReadAction from './courseRegisterIndividualRead.action.json' assert { type: 'json' }

const courseRegisterIndividualReadDefinition = defineReadAutoAction(courseRegisterIndividualReadAction, 'courseRegisterIndividual')

export default courseRegisterIndividualReadDefinition
